import React from "react";
import { Sparkles, X } from "lucide-react";

export const ExtractModal = ({
  extractModal, setExtractModal, toggleExtractRow, updateExtractRow, confirmBulkInsert,
}) => {
  if (!extractModal) return null;
  return (
    <div className="fixed inset-0 z-50 bg-[#2D322B]/80 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto" data-testid="extract-modal">
      <div className="bg-[#F9F6F0] rounded-3xl max-w-4xl w-full my-8 max-h-[90vh] flex flex-col">
        <div className="flex items-start justify-between p-6 border-b border-[#D1C7B8]">
          <div className="flex items-start gap-3">
            <Sparkles className="w-5 h-5 text-[#D49A44] mt-1" />
            <div>
              <p className="label-eyebrow text-[#D49A44]">Gemini 3 Pro · Lab extraction</p>
              <h2 className="font-serif text-2xl text-[#2D322B] mt-1">Confirm what to import</h2>
              <p className="text-sm text-[#5C6359] mt-1">
                Found {extractModal.entries.length} entries. Uncheck anything that looks off — edit values inline.
              </p>
            </div>
          </div>
          <button onClick={() => setExtractModal(null)} data-testid="extract-modal-close" className="text-[#5C6359] hover:text-[#C05C42]">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-b border-[#D1C7B8]">
          <div>
            <label className="text-[10px] uppercase tracking-widest text-[#5C6359] block mb-1">Lab / Provider</label>
            <input
              value={extractModal.labName}
              onChange={(e) => setExtractModal((m) => ({ ...m, labName: e.target.value }))}
              placeholder="e.g. Quest Diagnostics"
              data-testid="extract-lab-name"
              className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-1 outline-none text-[#2D322B] font-serif"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest text-[#5C6359] block mb-1">Report date</label>
            <input
              type="date"
              value={extractModal.labDate?.slice(0, 10) || ""}
              onChange={(e) => setExtractModal((m) => ({ ...m, labDate: e.target.value }))}
              data-testid="extract-lab-date"
              className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-1 outline-none text-[#2D322B] font-serif"
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-widest text-[#5C6359]">
              <tr>
                <th className="text-left pb-2 w-8"></th>
                <th className="text-left pb-2">Marker</th>
                <th className="text-left pb-2 w-28">Value</th>
                <th className="text-left pb-2 w-24">Unit</th>
                <th className="text-left pb-2 w-32">Date</th>
              </tr>
            </thead>
            <tbody>
              {extractModal.entries.map((e, i) => {
                const checked = extractModal.selected.has(i);
                return (
                  <tr key={`${e.marker}-${e.date}-${i}`} className={`border-t border-[#D1C7B8] ${checked ? "" : "opacity-40"}`} data-testid={`extract-row-${i}`}>
                    <td className="py-2">
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => toggleExtractRow(i)}
                        data-testid={`extract-check-${i}`}
                        className="accent-[#C05C42] w-4 h-4"
                      />
                    </td>
                    <td className="py-2 pr-3">
                      <input
                        value={e.marker}
                        onChange={(ev) => updateExtractRow(i, "marker", ev.target.value)}
                        className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#2D322B] font-serif"
                      />
                    </td>
                    <td className="py-2 pr-3">
                      <input
                        value={e.value}
                        onChange={(ev) => updateExtractRow(i, "value", ev.target.value)}
                        className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#C05C42]"
                      />
                    </td>
                    <td className="py-2 pr-3">
                      <input
                        value={e.unit}
                        onChange={(ev) => updateExtractRow(i, "unit", ev.target.value)}
                        className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#5C6359]"
                      />
                    </td>
                    <td className="py-2">
                      <input
                        value={e.date || ""}
                        onChange={(ev) => updateExtractRow(i, "date", ev.target.value)}
                        placeholder="YYYY-MM-DD"
                        className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#5C6359]"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="border-t border-[#D1C7B8] p-6 flex items-center justify-between">
          <p className="text-xs text-[#5C6359]" data-testid="extract-selected-count">
            {extractModal.selected.size} of {extractModal.entries.length} selected
          </p>
          <div className="flex gap-3">
            <button onClick={() => setExtractModal(null)} className="btn-secondary !py-2 !px-5" data-testid="extract-cancel">
              Cancel
            </button>
            <button onClick={confirmBulkInsert} className="btn-primary !py-2 !px-5" data-testid="extract-confirm">
              Import selected
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
